// extracted by mini-css-extract-plugin
export var numberInputContainer = "_77-0";
export var startPickingButton = "_77-1";